<div class="dialog">
  <button
    type="button"
    class="dialog__close btn btn_close"
    aria-label="close"
    (click)="closeModal()"
  >
    <i class="icon icon_cross"></i>
  </button>

  <div class="dialog__content">
    <div class="dialog__title" i18n="@@ui.confirm_bet.title">Внимание!</div>
    <div class="dialog__subtitle" i18n="@@ui.confirm_bet.subtitle">Вы уверены, что хотите войти в игру за <span class="dialog__bet-amount" [convert]="data"></span>. Ставку отменить нельзя</div>

    <div class="dialog__switch">
      <label class="switch" for="switch">
        <span class="switch__title" i18n="@@ui.confirm_bet.never_ask_again">Больше не спрашивать</span>

        <input class="switch__control" type="checkbox" id="switch"
          [(ngModel)]="neverAskAgain" />

        <span class="switch__slider"></span>
      </label>
    </div>

    <div class="dialog__actions">
      <button class="btn btn_blue" type="button"
        i18n="@@ui.confirm_bet.yes"
        (click)="closeModal(true)"
      >Да</button>

      <button class="btn btn_blue-bordered" type="button"
        i18n="@@ui.confirm_bet.no"
        (click)="closeModal()"
      >Нет</button>
    </div>
  </div>
</div>
